import React from "react";
import { connect } from "react-redux";

// Components
import BodyWrap from "../utils/BodyWrap";
import Banners from "./Banners";
import Loader from "../utils/Loader";
import HomeContent from "./HomeContent";
import NewsListing from "./news/NewsListing";
import HomeListingsPano from "./HomeListingsPano";

// CSS
import "../../css/main-body.css";

// State
import { getTranslations } from "../../store/actions/translations";
import { getBanners } from "../../store/actions/banners";
import { getNews, clearNews } from "../../store/actions/news";

class Home extends React.PureComponent {
	static initialAction(store, props, translationKey = null) {
		const promises = [];

		// Translations
		const translationSections = [
			"buttons",
			"review_registration_dialog",
			"training_listing",
			"reviews_listing",
			"news_listing"
		];

		if (translationKey === null) {
			translationKey = props.translationKey;
		}

		const resTranslations =
			store !== null
				? getTranslations([translationKey], translationSections, translationKey)
				: props.getTranslations([translationKey], translationSections, translationKey);
		promises.push(resTranslations);

		// Other stuff the homepage needs
		if (store !== null) {
			promises.push(getBanners());
			promises.push(getNews());
		} else {
			promises.push(props.getBanners());
			promises.push(props.getNews());
		}

		return promises;
	}

	// ===================================
	//  LIFE CYCLE
	// ===================================
	componentDidMount() {
		if (!this.props.news) {
			Home.initialAction(null, this.props);
		}
	}

	componentWillUnmount() {
		this.props.clearNews();
	}

	// ===================================
	//  RENDER
	// ===================================
	render() {
		const { translationsLoading } = this.props;

		return (
			<BodyWrap>
				<main>
					<Banners />
					<div className="page-content">
						{translationsLoading ? (
							<Loader />
						) : (
							<React.Fragment>
								<div className="section-row">
									<HomeContent />
									{!!this.props.reviewer && <HomeListingsPano />}
								</div>
								<div className="section-row">
									<NewsListing />
								</div>
							</React.Fragment>
						)}
					</div>
				</main>
			</BodyWrap>
		);
	}
}

const mapStateToProps = (state, props) => {
	return {
		translationsLoading:
			state.translations.isLoading[props.translationKey] === undefined
				? 1
				: state.translations.isLoading[props.translationKey],
		translations: state.translations.translations,
		banners: state.banners.banners,
		reviewer: state.user.reviewer
	};
};

export default connect(
	mapStateToProps,
	{ getTranslations, getBanners, getNews, clearNews }
)(Home);



// WEBPACK FOOTER //
// ./src/components/home/Home.js